import Navigation from './navigation';

const navigation = new Navigation();
export {navigation};
